module.exports = __webpack_public_path__ + "static/img/bg1.9630b741.png";